import { EVENT, EVENT_ACTION } from '@utils/tracking/constants'
import {
  computeAmexLabel,
  getEventCategory,
  getTargetMetaData,
} from '@utils/tracking/utils'
import { type SyntheticEvent, useCallback } from 'react'

import { useTrackingWrapper } from './use-tracking-wrapper'

export const useTrackNavigationLink = () => {
  const wrapper = useTrackingWrapper()

  return useCallback(
    (event: SyntheticEvent) => {
      if (wrapper) {
        const { href, isAmexLinkToTrack, defaultLabel } =
          getTargetMetaData(event)

        const libelle = isAmexLinkToTrack
          ? computeAmexLabel(href, 'en_savoir_plus_sur_la_carte')
          : defaultLabel

        wrapper.triggerEvent(EVENT.CLICK, event.currentTarget, {
          categorie: getEventCategory(wrapper),
          action: EVENT_ACTION.CLIC_NAVIGATION,
          libelle,
        })
      }
    },
    [wrapper]
  )
}
